<template>
  <div
    :id="gramId"
    class="ud-Visit_Gram"
    :class="{ 'ud-Visit_Gram_Omo': isOmo }"
  >
    <div class="ud-Visit_GramIcon">
      <div class="ud-Visit_GramIcon_Circle">
        <div style="margin-top: -1px;">
          <Icon :icon="icon" :size="22" :color="iconColor" />
        </div>
      </div>
    </div>
    <div class="ud-Visit_GramBody">
      <div class="ud-Visit_GramTime">{{ time }}</div>
      <div class="ud-Visit_GramAction">{{ title }}</div>
      <div v-if="description" class="ud-Visit_GramActionDetail">
        <div class="Visit_GramActionDetailText">{{ description }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import GramBase from "@/components/observation/visit/gram/GramBase.vue";
import { Gram } from "@/models/Gram";
import { Icons } from "@/const/Icons";
import Icon from "@/components/Icon.vue";
import { Colors } from "@/const/Colors";

@Component({
  components: { Icon }
})
export default class GramNpsEnqt extends GramBase {
  @Prop({ type: Gram, required: true })
  gram!: Gram;

  @Prop({ type: Boolean, required: true })
  isOmo!: boolean;

  iconColor = Colors.Blue900;

  get icon(): string {
    return Icons.Loyalty;
  }

  get gramId(): string {
    return this.gram.id;
  }

  get time(): string {
    return this.gram.hasTimeOfDay ? this.gram.timeTx : "";
  }

  get title(): string {
    return this.gram.npsEnqtTitle;
  }

  get description(): string {
    return this.gram.npsEnqtDescription;
  }
}
</script>
